<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                hide-details
                :value="date"
                color="gray"
                :label="label"
                append-icon="mdi-calendar"
                readonly
                :outlined="outlined"
                v-bind="attrs"
                v-on="on"
                :disabled="disabled"
                :rules="required ? [validationRules.required] : []"
                ref="innerDateField"
            ></v-text-field>
        </template>
        <v-date-picker
            locale="ru"
            show-adjacent-months
            :range="isRange"
            :allowed-dates="date => !future_disabled || date <= new Date().toISOString().substr(0, 10)"
            v-model="dateModel"
            color="gray"
            scrollable
        >
            <v-spacer></v-spacer>
            <v-btn color="gray" outlined @click="menu = false">
                Отмена
            </v-btn>
            <v-btn color="gray" class="white--text" @click="saveDate">
                Сохранить
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>
<script>
import { validationRules } from '@/utils/validationRules';

export default {
    name: 'PreTrialDatePicker',
    computed: {
        validationRules() {
            return validationRules;
        }
    },
    props: {
        label: {
            required: true
        },
        isRange: {
            type: Boolean,
            default: false
        },
        date: {},
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        },
        future_disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            menu: false,
            dateModel: this.isRange ? [] : null
        };
    },
    methods: {
        saveDate() {
            this.$refs.menu.save();
            this.$emit('update:date', this.dateModel);
        },
        validateDateField() {
            this.$refs.innerDateField.validate(true);
        }
    }
};
</script>

<style scoped></style>
